import { render, staticRenderFns } from "./receiveLimitContent.vue?vue&type=template&id=37dd2f68&scoped=true&"
import script from "./receiveLimitContent.vue?vue&type=script&lang=js&"
export * from "./receiveLimitContent.vue?vue&type=script&lang=js&"
import style0 from "./receiveLimitContent.vue?vue&type=style&index=0&id=37dd2f68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd2f68",
  null
  
)

export default component.exports